import { secureStorage_getItem } from '../utility/secureStorage';

// Base GraphQL client function
const graphqlClient = async ({ query, variables = {} }) => {
    const accessToken = secureStorage_getItem("idtoken") ||
        secureStorage_getItem("accesstoken") ||
        secureStorage_getItem("vlomni_id_token") ||
        secureStorage_getItem("vlomni_access_token");

    const headers = {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json"
    };

    const requestOptions = {
        method: "POST",
        headers,
        body: JSON.stringify({ query, variables })
    };

    try {
        const response = await fetch("https://ddzh7n3sd5er7l3whlni3qauja.appsync-api.us-east-1.amazonaws.com/graphql", requestOptions);
        const result = await response.json();

        if (result.errors) {
            throw new Error(result.errors[0].message);
        }

        return result;
    } catch (error) {
        throw error;
    }
};

const createAmazonSPCreds = async (input) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${secureStorage_getItem("accesstoken") ||
        secureStorage_getItem("idtoken") ||
        secureStorage_getItem("vlomni_id_token") ||
        secureStorage_getItem("vlomni_access_token")}`);
    myHeaders.append("Content-Type", "application/json");

    const graphql = JSON.stringify({
        query: `mutation {
            createAmazonSPCreds(
                input:{
                    CustomerID:${input.CustomerID},
                    SellerID: "${input.SellerID}",
                    MarketPlaceId: "${input.MarketPlaceID}", 
                    AccessToken: "${input.AccessToken}", 
                    RefreshToken: "${input.RefreshToken}", 
                }) {
                CustomerID
            }
        }`,
        variables: {}
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql
    };

    try {
        const response = await fetch("https://ddzh7n3sd5er7l3whlni3qauja.appsync-api.us-east-1.amazonaws.com/graphql", requestOptions);
        const result = await response.json();

        if (result.errors) {
            throw new Error(result.errors[0].message);
        }

        return result;
    } catch (error) {
        throw new Error(`Failed to create Amazon SP credentials: ${error.message}`);
    }
};

const updateAmazonSPCreds = async (input) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${secureStorage_getItem("accesstoken") ||
        secureStorage_getItem("idtoken") ||
        secureStorage_getItem("vlomni_id_token") ||
        secureStorage_getItem("vlomni_access_token")}`);
    myHeaders.append("Content-Type", "application/json");

    const graphql = JSON.stringify({
        query: `mutation {
            updateAmazonSPCreds(input:{
                CustomerID:${input.CustomerID},
                SellerID: "${input.SellerID}",
                MarketPlaceId: "${input.MarketPlaceID}", 
                AccessToken: "${input.AccessToken}", 
                RefreshToken: "${input.RefreshToken}", 
            }) {
                CustomerID
            }
        }`,
        variables: {}
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql
    };

    try {
        const response = await fetch("https://ddzh7n3sd5er7l3whlni3qauja.appsync-api.us-east-1.amazonaws.com/graphql", requestOptions);
        const result = await response.json();

        if (result.errors) {
            throw new Error(result.errors[0].message);
        }

        return result;
    } catch (error) {
        throw new Error(`Failed to update Amazon SP credentials: ${error.message}`);
    }
};

const listAmazonSPCreds = async (filter, fields, nextToken, limit = 1000) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${secureStorage_getItem("accesstoken") ||
        secureStorage_getItem("idtoken") ||
        secureStorage_getItem("vlomni_id_token") ||
        secureStorage_getItem("vlomni_access_token")}`);
    myHeaders.append("Content-Type", "application/json");

    let filterPart = '';
    if (filter && filter.length > 0) {
        filterPart = `, filter: { ${filter.join(', ')} }`;
    }

    let nextTokenPart = '';
    if (nextToken) {
        nextTokenPart = `, nextToken: "${nextToken}"`;
    }

    const graphql = JSON.stringify({
        query: `query {
            listAmazonSPCreds(limit: ${limit}${filterPart}${nextTokenPart}) {
                items {
                    ${fields}
                }
                nextToken
            }
        }`,
        variables: {}
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql
    };

    try {
        const response = await fetch("https://ddzh7n3sd5er7l3whlni3qauja.appsync-api.us-east-1.amazonaws.com/graphql", requestOptions);
        const result = await response.json();

        if (result.errors) {
            throw new Error(result.errors[0].message);
        }

        return result;
    } catch (error) {
        throw new Error(`Failed to list Amazon SP credentials: ${error.message}`);
    }
};

export default {
    createAmazonSPCreds,
    updateAmazonSPCreds,
    listAmazonSPCreds
};